import { useState, useEffect } from 'react';
import { useUser } from 'shared/auth';
import { getBaseUrl } from 'shared/apollo/client';

const angularBaseUrlMap = {
  localhost: 'http://localhost:8000',
  'alpha.trueimpact.com': 'https://v3.trueimpact.com',
};
export const getAngularBaseUrl = () =>
  angularBaseUrlMap[window.location.hostname] || 'https://ir.trueimpact.com';

export function useFetch(url, options = {}) {
  const [result, setResult] = useState();
  const user = useUser();

  useEffect(() => {
    if (!user || !user.effectiveUser || !user.password) {
      return;
    }

    const ghosting = user.ghostedUsername ? `#${user.ghostedUsername}` : '';
    const authorizationRaw = `${user.authUser.attributes.email}${ghosting}:${user.password}`;
    const authorization = `Basic ${window.btoa(authorizationRaw)}`;

    let active = true;

    (async () => {
      const response = await fetch(getBaseUrl() + url, {
        ...options,
        headers: {
          ...options.headers,
          Authorization: authorization,
        },
      });

      const json = await response.json();
      if (active) {
        setResult(json);
      }
    })();

    return () => {
      active = false;
    };
  }, [user]);

  return result;
}
